export default __webpack_public_path__ + "static/media/Lera_Buns.700c6288.png";